import positions from '../constants/positions';
import { TEXT_RESIZE_HANDLER_SIZE } from '../constants/common';

const getOffsetLeft = (elementRect, position, indent) =>
  position === positions.LEFT
    ? elementRect.left - indent - TEXT_RESIZE_HANDLER_SIZE / 2
    : elementRect.right + indent - TEXT_RESIZE_HANDLER_SIZE / 2;

export default getOffsetLeft;
